// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"43":"e094ed1b","856":"fcab3ede"}[chunkId] + ".js";
};